import React, { useState, useContext, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import google from "../../assets/images/google.svg";
import facebook from "../../assets/images/facebook.svg";
import ParameterContext from "../../context/parameter/parameterContext";
import AuthContext from "../../context/auth/authContext";
import OTPScreen from "./OTPScreen";
import ForgotPasswordOTPScreen from "./ForgotPasswordOTPScreen";
import { toast } from "react-toastify";
const Register = () => {
  const { toggleModal, modal } = useContext(ParameterContext);
  const {
    registerUser,
    loginUser,
    loading,
    userData,
    userDetailsForOTP,
    changePasswordRequest,
  } = useContext(AuthContext);
  const [toggleAuth, setToggleAuth] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [nameError, setNameError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [showForgot, setShowForgot] = useState(false);
  const [showForgotInstructions, setShowForgotInstructions] = useState(false);
const closeForgot=()=>{
  setShowForgot(false);
};
  const passwordRequest = () => {
    if (email === "") {
      setEmailError("Email cannot be empty");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      setEmailError("Please enter a valid email");
    } else {
      changePasswordRequest({ email }).then((data) => {
if(data){
  setShowForgotInstructions(true);
}
      }).catch((error) => {
        console.log(error)
      });
    }
  };
  const handleRegisterSubmit = () => {
    if (name === "" || name === null) {
      setNameError("Name cannot be empty");
    } else if (name.length > 24) {
      setNameError("Count of Characters in name cannot exceed 24");
    } else if (email === "") {
      setEmailError("Email cannot be empty");
    } else if (password === "") {
      setPasswordError("Password cannot be empty");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      setEmailError("Please enter a valid email");
    } else if (
      !/^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
        password
      )
    ) {
      setPasswordError("Password should be Strong");
    } else {
      registerUser({ name, email, password });
    }
  };
  useEffect(() => {
    if (userDetailsForOTP) {
      setShowOTP(true);
    }
  }, [userDetailsForOTP]);

  useEffect(() => {
    setNameError(null);

    //eslint-disable-next-line
  }, [name, toggleAuth]);
  useEffect(() => {
    setPasswordError(null);

    //eslint-disable-next-line
  }, [password, toggleAuth]);

  useEffect(() => {
    setEmailError(null);

    //eslint-disable-next-line
  }, [email, toggleAuth]);
  const handleLoginSubmit = () => {
    if (email === "") {
      setEmailError("Email cannot be empty");
    } else if (password === "") {
      setPasswordError("Password cannot be empty");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      setEmailError("Please enter a valid email");
    } else if (
      !/^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
        password
      )
    ) {
      setPasswordError("Invalid Credentials");
    } else {
      loginUser({ email, password });
    }
  };

  return showOTP ? (
    <OTPScreen />
  ) : modal && !userData?.profile_data ? (
    showForgot ? (
      showForgotInstructions ? (
        <ForgotPasswordOTPScreen  />
      ) : (
        <div className="Register">
          <div className="Login__container">
            <div style={{ textAlign: "right" }}>
              <IoIosCloseCircleOutline
                size={40}
                style={{ cursor: "pointer" }}
                onClick={toggleModal}
              />
            </div>
            <div className="Register__content">
              <h2>Forgot Password</h2>
              <p>
                Enter your email below, you will receive an email with
                instructions on how to reset your password in a few minutes. You
                can also set a new password if you’ve never set one before.
              </p>
            </div>
            <div className="Register__form">
              <p>Email Address</p>
              <input
                type="email"
                placeholder="&#xF003;&nbsp; Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ borderColor: emailError ? "red" : "" }}
              />

              {emailError && (
                <p style={{ fontSize: "14px", color: "red" }}>{emailError}</p>
              )}

              <div className="Register__footer">
                <button
                  className="Register__button"
                  onClick={passwordRequest}
                  disabled={loading}
                >
                  Send OTP
                  {loading && (
                    <div
                      className="loader1"
                      style={{
                        height: "20px",
                        width: "20px",
                        display: "inline-block",
                        border: "3px solid #f3f3f3",
                        borderTop: "3px solid #8d0792",
                        marginLeft: "5px",
                      }}
                    ></div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )
    ) : toggleAuth ? (
      <div className="Register">
      <div className="Register__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={toggleModal}
          />
        </div>
        <div className="Register__content">
          <h2>Create an Account</h2>
          <p>
            Gain access to additional features such as Watchlist and Portfolio
            tracking. Already have an account?&nbsp;
            <span
              style={{ color: "#8D0792", cursor: "pointer" }}
              onClick={() => {
                setToggleAuth((prev) => !prev);
              }}
            >
              Log In
            </span>
          </p>
        </div>
        <div className="Register__form">
          <p>Name</p>
          <input
            type="text"
            placeholder="&#xF007;&nbsp; Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ borderColor: nameError ? "red" : "" }}
          />
          {nameError && (
            <p style={{ fontSize: "14px", color: "red" }}>{nameError}</p>
          )}
          <p>Email Address</p>
          <input
            type="email"
            placeholder="&#xF003;&nbsp; Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ borderColor: emailError ? "red" : "" }}
          />
          {emailError && (
            <p style={{ fontSize: "14px", color: "red" }}>{emailError}</p>
          )}
          <p>Password</p>
          <input
            type="password"
            placeholder="&#xF023;&nbsp; Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ borderColor: passwordError ? "red" : "" }}
          />
          {passwordError && (
            <p style={{ fontSize: "14px", color: "red" }}>{passwordError}</p>
          )}
          <div className="Register__footer">
            <button
              className="Register__button"
              onClick={handleRegisterSubmit}
              disabled={loading}
            >
              Create Account{" "}
              {loading && (
                <div
                  className="loader1"
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "inline-block",
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #8d0792",
                    marginLeft: "5px",
                  }}
                ></div>
              )}
            </button>
            <span>OR</span>
            <div className="Register__social">
              <a href="https://api.coinstorey.com/accounts/cr_acc/facebook">
                <img src={facebook} alt="fb" style={{ margin: "10px" }} />
              </a>

              <a href="https://api.coinstorey.com/accounts/cr_acc/google">
                <img src={google} alt="google" />
              </a>
            </div>
            <p>
              By proceeding, you agree to CoinStorey’s Terms of Use & Privacy
              Policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  
    ) : (
      <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={toggleModal}
          />
        </div>
        <div className="Register__content">
          <h2>Login</h2>
          <p>
            New to CoinStorey?&nbsp;
            <span
              style={{ color: "#8D0792", cursor: "pointer" }}
              onClick={() => {
                setToggleAuth((prev) => !prev);
              }}
            >
              Create an account
            </span>
          </p>
        </div>
        <div className="Register__form">
          <p>Email Address</p>
          <input
            type="email"
            placeholder="&#xF003;&nbsp; Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ borderColor: emailError ? "red" : "" }}
          />

          {emailError && (
            <p style={{ fontSize: "14px", color: "red" }}>{emailError}</p>
          )}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Password</p>{" "}
            <p
              onClick={() => setShowForgot(true)}
              className="forgot_password"
            >
              Forgot Password?
            </p>
          </div>
          <input
            type="password"
            placeholder="&#xF023;&nbsp; Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ borderColor: passwordError ? "red" : "" }}
          />
          {passwordError && (
            <p style={{ fontSize: "14px", color: "red" }}>{passwordError}</p>
          )}
          <div className="Register__footer">
            {" "}
            <button
              className="Register__button"
              onClick={handleLoginSubmit}
              disabled={loading}
            >
              Sign In{" "}
              {loading && (
                <div
                  className="loader1"
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "inline-block",
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #8d0792",
                    marginLeft: "5px",
                  }}
                ></div>
              )}
            </button>
            <span>OR</span>
            <div className="Register__social">
              <a href="https://api.coinstorey.com/accounts/cr_acc/facebook">
                <img src={facebook} alt="fb" style={{ margin: "10px" }} />
              </a>

              <a href="https://api.coinstorey.com/accounts/cr_acc/google">
                <img src={google} alt="google" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
 
    )
  ) : (
    <></>
  );
};

export default Register;
